import ReactDOM from "react-dom/client";
import "./index.css";
import { FloatingAiAssistant } from "@/components/ui/glowing-ai-chat-assistant";
import DemoOne from "@/components/ui/demo";

// Note: StrictMode intentionally disabled. It double-mounts effects in dev,
// which would open two WebSocket connections to the channel runtime (one
// per mount) and produce duplicate events (welcome shown twice, two
// "thinking" placeholders for each user message). Real production runs
// don't double-mount, so this only matters in dev.

const params = new URLSearchParams(window.location.search);
const embedBotId = params.get("bot");
const embedWsUrl = params.get("ws") || undefined;

const root = ReactDOM.createRoot(document.getElementById("root")!);

if (embedBotId) {
  // Embedded mode: rendered inside the iframe created by loader.js. The
  // host page is whatever the customer's site is — keep our HTML/body
  // background transparent so only the widget chrome paints.
  document.documentElement.style.background = "transparent";
  document.body.style.background = "transparent";
  document.body.style.margin = "0";
  root.render(<FloatingAiAssistant botId={embedBotId} wsUrl={embedWsUrl} />);
} else {
  // Standalone dev preview: shopping-site mock so we can see the widget in
  // a realistic context.
  root.render(
    <div
      className="min-h-screen text-zinc-100 relative"
      style={{
        background:
          "linear-gradient(135deg, #fdf8f2ff 0%, #fbcfe8 35%, #f9a8d4 65%, #ec4899 100%)",
      }}
    >
      <div className="absolute inset-0 bg-white/5 pointer-events-none" />

      <div className="relative">
        <header className="border-b border-white/10 bg-white/5 backdrop-blur-md">
          <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
            <div className="text-lg font-semibold tracking-tight text-white drop-shadow">
              Acme Beauty
            </div>
            <nav className="hidden gap-6 text-sm text-zinc-100/90 md:flex">
              <a className="hover:text-white" href="#">Skincare</a>
              <a className="hover:text-white" href="#">Makeup</a>
              <a className="hover:text-white" href="#">Hair</a>
              <a className="hover:text-white" href="#">Fragrance</a>
              <a className="hover:text-white" href="#">Sale</a>
            </nav>
            <button className="rounded-full bg-white/10 px-4 py-1.5 text-sm font-medium text-white backdrop-blur-md hover:bg-white/15">
              Sign in
            </button>
          </div>
        </header>

        <main className="mx-auto max-w-6xl px-6 py-12">
          <h1 className="text-3xl font-semibold tracking-tight text-white drop-shadow-lg">
            New arrivals
          </h1>
          <p className="mt-2 max-w-xl text-sm text-zinc-100/85 drop-shadow">
            Lorem ipsum dolor sit amet consectetur. Ut purus sit amet ipsum
            venenatis venenatis lectus. Pretium tellus arcu et eu pharetra.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4">
            {[
              { name: "Hydra Glow Serum", price: "₹899" },
              { name: "Velvet Matte Lipstick", price: "₹499" },
              { name: "Volume Mascara Pro", price: "₹699" },
              { name: "Daily Sunscreen SPF 50", price: "₹549" },
              { name: "Repair Hair Mask", price: "₹749" },
              { name: "Niacinamide 10%", price: "₹399" },
              { name: "Cleansing Balm", price: "₹629" },
              { name: "Eau de Parfum", price: "₹1,299" },
            ].map((p) => (
              <div
                key={p.name}
                className="rounded-2xl border border-white/15 bg-white/10 p-3 backdrop-blur-md"
              >
                <div className="aspect-square rounded-xl bg-white/15" />
                <div className="mt-3 text-sm font-medium text-white drop-shadow">{p.name}</div>
                <div className="text-xs text-zinc-200/85">{p.price}</div>
              </div>
            ))}
          </div>
        </main>
      </div>

      <DemoOne />
    </div>,
  );
}
